import { ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import 'react-datepicker/dist/react-datepicker.css';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import ChatWidget from './components/ChatWidget/ChatWidget';
import { EmployeeContextProvider } from './context/employee/EmployeeContext';
import { ProvideAuth } from './hooks/useAuth';
import Routes from './routes';
import CustomizeTheme from './theme/CustomizeTheme';

const queryClient = new QueryClient();

const App = () => {
  return (
    <ThemeProvider theme={CustomizeTheme}>
      <QueryClientProvider client={queryClient}>
        <HelmetProvider>
          <BrowserRouter>
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLosswrite
              draggable
              pauseOnHover
              theme="light"
            />
            <ProvideAuth>
              <EmployeeContextProvider>
                <Routes />
                <ChatWidget />
              </EmployeeContextProvider>
            </ProvideAuth>
          </BrowserRouter>
        </HelmetProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
